
export default class StringUtils {

  static abbreviate(text, append = '...') {
    if (text.length < 30) {
      return text;
    }
    return text ? text.substring(0, 15) + append + text.slice(-10) : '';
  }

  static isBlank(str) {
    return (!str || /^\s*$/.test(str));
  }

  static trimToEmpty(str: string) {
    if (!!str) {
      return str.trim()
    }
    return ''
  }


}
